// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fDw1Z","content":"styles_content__3qhm8","row":"styles_row__3rQDa","footer":"styles_footer__3fG3X","phraseLength":"styles_phraseLength__2J4S6"};